import { render } from "./InformationList.vue?vue&type=template&id=551896ab&scoped=true"
import script from "./InformationList.vue?vue&type=script&lang=js"
export * from "./InformationList.vue?vue&type=script&lang=js"

import "./InformationList.vue?vue&type=style&index=0&id=551896ab&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551896ab"]])

export default __exports__